import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { PageHeader } from "@/pages/admin/AdminDashboard";
import { toast } from "sonner";
import { Building2, FileText } from "lucide-react";
import { LEGAL_ICONS } from "@/components/legal/LegalTabs";
import { LegalEditor } from "@/components/admin/legal/LegalEditor";
import { LegalEditeurForm } from "@/components/admin/legal/LegalEditeurForm";

export default function AdminLegal() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("cgv");

  const load = async () => {
    try { const { data: d } = await api.get("/admin/legal"); setData(d); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const docs = data?.documents || [];
  const doc = docs.find((d) => d.key === tab);

  return (
    <div className="min-h-full" data-testid="admin-legal-page">
      <PageHeader eyebrow="Conformité" title="Mentions légales · CGV · CGU" sub="Rédigez et publiez les documents légaux affichés sur le site public et dans les espaces gérant / salarié. Chaque publication crée une nouvelle version ; les gérants sont invités à accepter les CGV et CGU en vigueur." />
      <div className="p-6 lg:p-10 space-y-6">
        <div className="flex flex-wrap gap-1 border-b border-[#DEE2E6]" data-testid="admin-legal-tabs">
          {docs.map((d) => {
            const Icon = LEGAL_ICONS[d.key] || FileText;
            return (
              <button type="button" key={d.key} onClick={() => setTab(d.key)} data-testid={`admin-legal-tab-${d.key}`}
                className={`px-4 h-11 text-xs font-bold uppercase tracking-wider flex items-center gap-2 border-b-2 -mb-px ${tab === d.key ? "border-[#0A0A0A] text-[#0A0A0A]" : "border-transparent text-[#868E96] hover:text-[#0A0A0A]"}`}>
                <Icon className="h-3.5 w-3.5" />{d.title}
                <span className="font-mono text-[10px] px-1.5 py-0.5 bg-[#F1F3F5] text-[#495057]">v{d.version}</span>
                {d.has_draft && <span className="w-2 h-2 bg-[#F59E0B] rounded-full" title="Brouillon en attente" data-testid={`admin-legal-draft-dot-${d.key}`} />}
              </button>
            );
          })}
          <button type="button" onClick={() => setTab("editeur")} data-testid="admin-legal-tab-editeur"
            className={`px-4 h-11 text-xs font-bold uppercase tracking-wider flex items-center gap-2 border-b-2 -mb-px ${tab === "editeur" ? "border-[#0A0A0A] text-[#0A0A0A]" : "border-transparent text-[#868E96] hover:text-[#0A0A0A]"}`}>
            <Building2 className="h-3.5 w-3.5" />Identité de l'éditeur
          </button>
        </div>

        {!data ? <div className="text-sm text-[#868E96]" data-testid="admin-legal-loading">Chargement…</div>
          : tab === "editeur" ? <LegalEditeurForm fields={data.fields} value={data.editeur} onSaved={load} />
            : doc ? <LegalEditor key={doc.key} doc={doc} placeholders={data.placeholders} onSaved={load} /> : null}
      </div>
    </div>
  );
}
